/* assets/atd-sticky-mobile-atc.js */
(function () {
  const mq = window.matchMedia("(max-width: 575.98px)");
  const SECTION_ROOT =
    document.currentScript?.closest("[data-section]") || document;

  const stickyHost = SECTION_ROOT.querySelector(
    ".atd-product-sticky-footer__container"
  );
  if (!stickyHost) return;

  const iconUrl = stickyHost.getAttribute("data-icon-url");
  const scrollThreshold = parseInt(stickyHost.getAttribute("data-scroll-threshold"), 10) || 800;
  let svgCache = null;

  const animEl = SECTION_ROOT.querySelector(".atd-animated-label__container");
  const qtyEl = SECTION_ROOT.querySelector(".atd-product-quantity__container");
  const formEl = SECTION_ROOT.querySelector(
    'form[data-type="add-to-cart-form"]'
  );
  const submitBtn = formEl?.querySelector(".product-form__submit");

  if (!formEl || !submitBtn || !qtyEl || !animEl) return;

  // Save original parent and next sibling for animEl and qtyEl
  const animOriginalParent = animEl.parentNode;
  const animNextSibling = animEl.nextSibling;

  const qtyOriginalParent = qtyEl.parentNode;
  const qtyNextSibling = qtyEl.nextSibling;

  const state = {
    mounted: false,
    proxyBtn: null,
    rightWrap: null,
    mutationObserver: null,
    mounting: false, // lock to prevent duplicate mounts
    animPlaceholder: null,
    qtyPlaceholder: null,
  };

  async function loadIcon() {
    if (!iconUrl) return null;
    if (svgCache) return svgCache.cloneNode(true);
    try {
      const res = await fetch(iconUrl, { credentials: "omit" });
      if (!res.ok) return null;
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, "image/svg+xml");
      const svg = doc.documentElement;
      svg.setAttribute("aria-hidden", "true");
      svg.setAttribute("focusable", "false");
      svg.classList.add("atd-sticky-atc__icon");
      if (!svg.getAttribute("stroke"))
        svg.setAttribute("stroke", "currentColor");
      svgCache = svg;
      return svg.cloneNode(true);
    } catch (e) {
      console.error("Failed to load SVG icon:", e);
      return null;
    }
  }

  async function makeProxyButton() {
    if (state.proxyBtn) return state.proxyBtn;

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className =
      "btn btn-small text-body-base button--full-width btn-primary atd-sticky-atc";

    const icon = await loadIcon();
    if (icon) btn.appendChild(icon);

    btn.addEventListener("click", () => {
      if (btn.disabled) return;
      submitBtn.click();
    });

    const syncDisabled = () => {
      btn.disabled = submitBtn.disabled;
      btn.setAttribute(
        "aria-disabled",
        submitBtn.getAttribute("aria-disabled") ||
        (submitBtn.disabled ? "true" : "false")
      );
    };

    const mo = new MutationObserver(syncDisabled);
    mo.observe(submitBtn, {
      attributes: true,
      attributeFilter: ["disabled", "aria-disabled", "class"],
    });
    syncDisabled();
    state.mutationObserver = mo;

    state.proxyBtn = btn;
    return btn;
  }

  function createPlaceholder(el) {
    const ph = document.createElement("div");
    ph.style.height = el.offsetHeight + "px";
    ph.style.display = "block";
    ph.setAttribute("aria-hidden", "true");
    return ph;
  }

  async function mount() {
    if (state.mounted || state.mounting) return;
    state.mounting = true;

    await makeProxyButton();

    // Move animEl to sticky header (with placeholder to hold space)
    if (!stickyHost.contains(animEl)) {
      if (!state.animPlaceholder) {
        state.animPlaceholder = createPlaceholder(animEl);
        animEl.parentNode.insertBefore(state.animPlaceholder, animEl);
      }
      stickyHost.insertBefore(animEl, stickyHost.firstChild);
    }

    // Move quantity container to sticky footer
    if (!state.rightWrap) {
      const rightWrap = document.createElement("div");
      rightWrap.className = "atd-sticky-actions__container";
      if (!state.qtyPlaceholder) {
        state.qtyPlaceholder = createPlaceholder(qtyEl);
        qtyEl.parentNode.insertBefore(state.qtyPlaceholder, qtyEl);
      }
      rightWrap.appendChild(qtyEl);
      stickyHost.appendChild(rightWrap);
      state.rightWrap = rightWrap;
    } else if (!state.rightWrap.contains(qtyEl)) {
      state.rightWrap.appendChild(qtyEl);
    }

    // Insert proxy button as first child of qtyInner if not already there
    const qtyInner =
      qtyEl.querySelector(".atd-product-add-to-cart-qty-price__container") ||
      qtyEl;
    if (!qtyInner.contains(state.proxyBtn)) {
      qtyInner.insertBefore(state.proxyBtn, qtyInner.firstChild);
    }

    state.mounted = true;
    state.mounting = false;
  }

  function unmount() {
    if (!state.mounted) return;

    // Restore animEl to original position
    if (animEl.parentNode !== animOriginalParent) {
      animOriginalParent.insertBefore(animEl, animNextSibling);
    }
    if (state.animPlaceholder) {
      state.animPlaceholder.remove();
      state.animPlaceholder = null;
    }

    // Remove sticky container
    state.rightWrap?.remove();
    state.rightWrap = null;

    // Move qtyEl back to original parent
    if (qtyOriginalParent && !qtyOriginalParent.contains(qtyEl)) {
      qtyOriginalParent.insertBefore(qtyEl, qtyNextSibling);
    }
    if (state.qtyPlaceholder) {
      state.qtyPlaceholder.remove();
      state.qtyPlaceholder = null;
    }

    // Remove proxy button from qtyInner
    if (state.proxyBtn?.parentNode) {
      state.proxyBtn.parentNode.removeChild(state.proxyBtn);
    }

    state.mutationObserver?.disconnect();
    state.mounted = false;
  }

  function apply() {
    if (!mq.matches) {
      unmount();
      return;
    }

    if (window.scrollY > scrollThreshold) mount();
    else if (window.scrollY <= scrollThreshold && state.mounted) unmount();
  }

  function throttle(fn, wait = 100) {
    let last = 0;
    return function (...args) {
      const now = Date.now();
      if (now - last >= wait) {
        last = now;
        fn.apply(this, args);
      }
    };
  }

  const throttledApply = throttle(apply, 100);
  document.addEventListener("DOMContentLoaded", apply);
  if (
    document.readyState === "interactive" ||
    document.readyState === "complete"
  )
    apply();

  window.addEventListener("scroll", throttledApply);
  mq.addEventListener
    ? mq.addEventListener("change", apply)
    : mq.addListener(apply);
  SECTION_ROOT.addEventListener("variant:change", apply);
})();
